import { createFileRoute } from "@tanstack/react-router";
import { ApprovalPage } from "@/features/portalapprovals/ApprovalPage";

export const Route = createFileRoute("/portal/approvals/$approval")({ component: Page });

function Page() {
  const { approval } = Route.useParams();
  return <ApprovalPage id={approval} />;
}
